// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";

// Afidium
import { SectorsAirDetailsListComponent } from './sectors-air-details-list.component';
import { SectorAirFlightDetailsModule } from 'libraries/component/sector-air-flight-details/sector-air-flight-details.module';
import { RuptureModule } from 'libraries/rupture/rupture.module';
import { TravelDateBeginEndModule } from './components/traveller-date-begin-end/travel-date-begin-end.module';
import { SectorsAirCouponListModule } from '../sector-air-coupon-list/sector-air-coupon-list.module';
import { SectorsAirSimpleListModule } from "../sectors-air-simple-list/sectors-air-simple-list.module";
import { SectorFilterPipe } from "./pipes/sector-filter.pipe";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import { BtnModule } from "libraries/ui_button/btn.module";
import { RulesSearchFormModule } from "./components/rules-search-form/rules-search-form.module";
import { GetRelatedRulesPipe } from "libraries/component/sectors-air-details-list/pipes/get-related-rules.pipe";
import { PipesModule } from "libraries/pipes/pipes.module";
import { FareNoteRulesModule } from "libraries/component/sectors-air-details-list/components/fare-note-rules/fare-note-rules.module";
import { PermissionModule } from "libraries/permission/permission.module";
import {
    BookingTravellerTicketServiceModule
} from "libraries/component/booking-information/components/booking-traveller-card/components/booking-traveller/components/booking-traveller-ticket/services/booking-traveller-ticket-service.module";

@NgModule({
    imports: [
        BtnModule,
        CommonModule,
        RuptureModule,
        SectorAirFlightDetailsModule,
        SectorsAirCouponListModule,
        SectorsAirSimpleListModule,
        FontAwesomeModule,
        TravelDateBeginEndModule,
        RulesSearchFormModule,
        PipesModule,
        FareNoteRulesModule,
        PermissionModule,
        BookingTravellerTicketServiceModule,
    ],
    exports: [
        SectorsAirDetailsListComponent,
        SectorFilterPipe,
    ],
    declarations: [
        SectorsAirDetailsListComponent,
        SectorFilterPipe,
        GetRelatedRulesPipe,
    ],

})
export class SectorsAirDetailsListModule {}

